<template>
	<div>
		<notifications></notifications>
		<div :class="{'nav-open': $sidebar.showSidebar}">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				default: null
			}
		},
		created() {
			console.log()
		}
	}
</script>
<style>
	body {
		background-color: #1a1c1e !important;
	}
	.md-textarea {
		min-height: 400px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
	}

	.el-tabs__item.is-active {
		color: #dc3c44 !important;
	}

	.el-tabs__item:hover {
		color: #dc3c44 !important;
	}

	.el-tabs__active-bar {
		background-color: #dc3c44 !important;
	}

	.md-progress-bar-fill {
		background-color: #dc3c44 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.active {
		background-color: #55efc4;
		border-radius: 5px;
		padding: 2px 8px;
	}
	.neutral {
		background-color: #dc3c44;
		border-radius: 5px;
		padding: 2px 8px;
	}

	.late {
		background-color: #fab1a0;
		border-radius: 5px;
		padding: 2px 8px;
	}

	.warn {
		background-color: #f39c12;
		border-radius: 5px;
		padding: 2px 8px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.md-list-item-text {
		font-family: "Nunito", "Hanuman" !important;
	}

	.vdatetime {
		width: 100%;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container:after {
		background-color: #dc3c44 !important;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container {
		border-color: #dc3c44 !important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue